import { BridgeService } from '@/services'
import { DeepLinks } from '@/services/bridge/types'

const allowedDomains: string[] = ['.inter.co', '.bancointer.com.br', '.uatbi.com.br']
const allowedDeepLinks: string[] = ['bancointer://']

export const isValidUrl = (url: string): boolean => {
  if (allowedDeepLinks.some((deepLink) => url?.startsWith(deepLink))) {
    return true
  }
  try {
    const parsedUrl = new URL(url)
    return allowedDomains.some((domain) => parsedUrl.hostname?.endsWith(domain))
  } catch {
    return false
  }
}

export const handleNavigation = (route: string) => {
  if (!isValidUrl(route)) return
  if (route?.startsWith('https')) {
    const url = new URL(route, window.location.origin)
    window.location.href = url.toString()
  }
  if (route?.startsWith('bancointer')) {
    BridgeService.navigateToNativeScreen(route as DeepLinks)
  }
}
